/**
 * Ficmoon 品牌 - Subscribe 页面配置
 */
import { commonTexts } from './common'
import type { SubscribePageConfig } from './types'

export const resources = {
  vipBg: '/images/ficmoon/vip_bg.webp',
  memberSubscribeBg: '/images/ficmoon/member_subscribe_bg.webp',
  vipIcon: '/images/ficmoon/vip_icon2.png',
  vipDiscountIcon: '/images/ficmoon/vip_discount.png',
  discountBg: '/images/ficmoon/discount.avif',
} as const

export const colors = {
  redGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
  // purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
  purpleTextGradient: 'linear-gradient(90.00000000000006deg, rgba(223,137,38,0.56) 0%, rgba(238,177,114,0.3) 100%)',

  subscribeText1: '#FFD483',
  subscribeText2: '#FFD483',
  subscribeText3: '#FFD483',
  subscribeText4: '#AC6D1F',
} as const

export const subscribeConfig: SubscribePageConfig = {
  texts: commonTexts,
  resources,
  colors,
}
